(function AllInclusiveProperties($, Adzuki)
{
	"use strict";

	var AIP = {};

	AIP.ImageGallery = function init() {
		// inline carousel-style galleries
		var lgContainer = document.getElementById('lightgallery-inline');
		var inlineGallery;

		// hack - open inline carousel image to fullscreen on click, for non-mobile
		if (!Adzuki.is_mobile) {
			lgContainer.addEventListener('lgInit', function lgInitInline(event) {
				// var lgInstance = event.detail.instance;

				$(lgContainer).on('click', '.lg-item', function lgInlineItemClick() {
					// proper way. function is defined, just doesn't work...
					// lgInstance.toggleMaximize();

					// hack, but whatever, it works
					$(lgContainer).find('.lg-icon.lg-maximize').click();
				});
			});
		}

		inlineGallery = lightGallery(lgContainer, {
			licenseKey            : 'github',
			container             : lgContainer,
			plugins               : [lgAutoplay, lgThumbnail],
			download              : false,
			closable              : false,
			showMaximizeIcon      : true,
			slideShowAutoplay     : true,
			autoplayControls      : false,
			forceSlideShowAutoplay: true,
			progressBar           : false,
			dynamic               : true,
			dynamicEl             : $(lgContainer).data('gallery-images'),
		});

		inlineGallery.openGallery();


		// on-click fullscreen galleries
		$('img.lightgallery').on('click', function showGallery() {
			var gallery = lightGallery(this, {
				licenseKey: 'github',
				plugins   : [lgThumbnail],
				download  : false,
				dynamic   : true,
				dynamicEl : $(this).data('gallery-images'),
			});

			gallery.openGallery();
		});
	};

	Adzuki.Erez.AllInclusiveProperties = AIP;
}(jQuery, window.Adzuki || {}));
